import { Box, Typography } from "@mui/material";

import { HeaderWithLayoutProvider } from "remotes/HeaderWithLayoutProvider/HeaderWithLayoutProvider";

import { FooterWithLayoutProvider } from "../../components/Footer/FooterWithLayoutProvider";

export const StandaloneComponents = () => (
  <Box>
    <HeaderWithLayoutProvider />
    <Box m={2}>
      <Typography>
        Example of header and footer components used in another app like AEM
      </Typography>
    </Box>
    <FooterWithLayoutProvider />
  </Box>
);
